import React from 'react';

import { Button, Checkbox, Dialog, InputBase, NativeSelect } from '@mui/material';

import type { LuxPlusControls } from './WorkbookControls';

export const luxPlusMuiControls: LuxPlusControls = {
  Button: function NativeButton({ color: _color, ...props }) {
    return <Button variant="text" size="small" {...props} />;
  },
  Input: function NativeInput({ type, onChange, checked, value, ...props }) {
    if (type === 'checkbox') {
      return <Checkbox size="small" checked={checked} onChange={onChange} inputProps={props} sx={{ p: 0.5 }} />;
    }
    return (
      <InputBase
        type={type}
        value={value}
        onChange={onChange}
        inputProps={props}
        fullWidth
        sx={{
          font: 'inherit',
          color: 'inherit',
          border: '1px solid var(--lp-rule)',
          borderRadius: '2px',
          bgcolor: 'var(--lp-panel)',
          px: 0.5,
        }}
      />
    );
  },
  Select: function NativeSelectControl({ children, value, onChange, ...props }) {
    return (
      <NativeSelect
        value={value}
        onChange={onChange}
        inputProps={props}
        disableUnderline
        fullWidth
        sx={{ font: 'inherit', color: 'inherit' }}
      >
        {children}
      </NativeSelect>
    );
  },
  Dialog: function NativeDialog({ open, onClose, children, className }) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        disablePortal
        maxWidth="md"
        fullWidth
        aria-labelledby="lp-info-title"
        PaperProps={{ className, sx: { bgcolor: 'var(--lp-panel)', color: 'var(--lp-ink)' } }}
      >
        {children}
      </Dialog>
    );
  },
};
